"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Utilitná funkcia pre nastavenie hodnoty do objektu alebo poľa. Funkcia nemutuje pôvodný objekt.
 * @param {object | array} - objekt pre iteráciu (povinný)
 * @param {string[] | number[]} - cesta k hodnote. (povinný)
 * @param {any} - hodnota, ktorú chceme do objektu alebo poľa nastaviť (povinný)
 * @returns {object | array} - Znovuvytvorené, ovplyvnené pole alebo objekt
 * @example
 * ```javascript
 * import setProp from 'utilities/lib/setProp';
 *
 * const object = {
 *   property: {
 *     anotherProperty: 'anotherPropertyValue',
 *   },
 * };
 *
 * const array = [true];
 *
 * console.log(
 *   setProp(
 *     object,
 *     ['property', 'anotherProperty'],
 *     'anotherPropertyModifiedValue',
 *   ),
 * );
 *
 * // {
 * //   property: {
 * //     anotherProperty: 'anotherPropertyModifiedValue'
 * //   }
 * // }
 *
 * console.log(
 *   setProp(object, ['property', 'anotherProperty2'], 'anotherProperty2Value'),
 * );
 *
 * // {
 * //   property: {
 * //     anotherProperty: 'anotherPropertyValue',
 * //     anotherProperty2: 'anotherProperty2Value'
 * //   }
 * // }
 *
 * console.log(setProp(array, [2], 'value'));
 *
 * // [true, empty, "value"]
 * ```
 */
function setProp(obj, path, value) {
    var objCopy;
    if (Array.isArray(obj)) {
        objCopy = __spreadArrays(obj);
    }
    else {
        objCopy = Object.assign({}, obj);
    }
    var acc = objCopy;
    for (var i = 0; i < path.length; i++) {
        var key = path[i];
        var nextKey = path[i + 1];
        if (i === path.length - 1) {
            acc[key] = value;
        }
        else {
            if (Array.isArray(acc)) {
                // we are in array, so we are expecting next segment to be index (if not, we throw)
                if (typeof key !== 'number') {
                    throw 'Type violation. Cannot access array element with non integer index.';
                }
            }
            else if (typeof acc === 'object') {
                // we are in object, so we are expecting next segment to be string (if not, we throw)
                if (typeof key === 'number') {
                    throw 'Type violation. Cannot set integer properties on object (convert it to string).';
                }
            }
            if (typeof acc[key] === 'undefined') {
                // determine type to create (array, object, primitive)
                if (typeof nextKey === 'string') {
                    // next will be object
                    acc[key] = {};
                }
                else if (typeof nextKey === 'number') {
                    // next will be array
                    acc[key] = [];
                }
                else {
                    // there is no next - it's primitive
                }
            }
            if (Array.isArray(acc[key])) {
                acc[key] = __spreadArrays(acc[key]);
                acc = acc[key];
            }
            else {
                acc[key] = Object.assign({}, acc[key]);
                acc = acc[key];
            }
        }
    }
    return objCopy;
}
exports.default = setProp;
